module.exports = __webpack_public_path__ + "rsa_70x70.8ec6b1fd3ab4139d2288c01a9b6fcccf.png";